import { Navigate, Route, Routes } from 'react-router-dom'

import { usePermissions } from '@/features/authorization/contexts/PermissionsContext'
import NavigateToError from '@/features/error/pages/NavigateToError'
import { WholesaleLayoutRouteInformation } from '@/features/wholesale/constants/routes'
import ImportTrade from '@/features/wholesale/pages/ImportTrade'
import ProductionPlanExport from '@/features/wholesale/pages/ProductionPlanExport'
import WholesaleLayout from '@/features/wholesale/pages/WholesaleLayout'

export default function WholesaleRoutes() {
  const { permissions } = usePermissions()
  const canMutateWholesale = permissions.has('wholesaleMutation')

  const defaultRoute = canMutateWholesale
    ? WholesaleLayoutRouteInformation.INDEX.routePath
    : WholesaleLayoutRouteInformation.PRODUCTION_PLAN_EXPORT.routePath

  return (
    <Routes>
      <Route element={<WholesaleLayout />} path="/">
        <Route index element={<Navigate replace to={defaultRoute} />} />
        {canMutateWholesale && (
          <Route element={<ImportTrade />} path={WholesaleLayoutRouteInformation.IMPORT_TRADE.routePath} />
        )}
        <Route
          element={<ProductionPlanExport />}
          path={WholesaleLayoutRouteInformation.PRODUCTION_PLAN_EXPORT.routePath}
        />
      </Route>

      <Route element={<NavigateToError statusCode={404} />} path="*" />
    </Routes>
  )
}
